/* eslint-disable no-undef */

// RequestHandler
import RequestHandler from './RequestHandler.js';

/**********************************************************
 *    Login Routes
 * 
 *  - Handles all requests for login, logout and signup
 *  - Also validates username
 * 
 **********************************************************/

/**********************************************************
 *  Validation Functions
 **********************************************************/

// Given a username, determine if it's valid
function isUsernameTaken(username) {

	console.log('LoginRoutes.isUsernameTaken()');

    var query = `/app/username/` + username;

    return RequestHandler.getRequest(query, false)

}


/**********************************************************
 *  Login/Logout Functions
 **********************************************************/

// Given a username and password, validate user login
function login(credentials) {

    //console.log('LoginRoutes.login()');
    
    return RequestHandler.postRequest('/app/login', credentials, false);

}

// Given a token, logout user
function logout(token) {
    
    //console.log('LoginRoutes.logout()');

    return RequestHandler.getRequest('/app/logout', true);

}


/**********************************************************
 *  Signup Functions
 **********************************************************/

// Given a sanitized username, email and password, create a new user
function signup(credentials) {

    //console.log('LoginRoutes.signup()');
    
    return RequestHandler.postRequest('/app/signup', credentials, false);
            
}

// Activate a given user
function activateUser(username) {

    //console.log('LoginRoutes.validateUser()');

    const endpoint = `/app/signup/activate/` + username;
        
    return RequestHandler.getRequest(endpoint, false);

}

/**********************************************************
 *  Subscribe Functions
 **********************************************************/

 // Subscribe to yety mailing list
function subscribe(email) {

    //console.log('LoginRoutes.subscribe()');

    const endpoint = `/app/subscribe/` + email;
        
    return RequestHandler.getRequest(endpoint, false);

}


const LoginRoutes = { isUsernameTaken, login, signup, logout, activateUser, subscribe };
export default LoginRoutes;



// WEBPACK FOOTER //
// ./src/Routes/LoginRoutes.js